"use client"

import * as React from "react"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList } from 'recharts';
import {
    Card, CardContent, CardHeader, CardTitle, CardDescription,
} from "src/@/components/ui/card"
import { ChartContainer } from "src/@/components/ui/chart"
import { Tooltip as ShadTooltip, TooltipContent as ShadTooltipContent, TooltipProvider, TooltipTrigger } from "src/@/components/ui/tooltip"
import { Info } from "lucide-react"
import EmptyContentGhost from "src/components/EmptyContentGhost"

const chartConfig = {
    avgDias: { label: "Média (dias)", color: "#f59e0b" },
};

export function GraficoAgingEtapas({ chartData = [] }) {
    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <div className="flex items-center gap-1">
                        <CardTitle>Aging por Etapa</CardTitle>
                        <TooltipProvider>
                            <ShadTooltip>
                                <TooltipTrigger asChild>
                                    <Info className="w-3.5 h-3.5 text-gray-400 cursor-help" />
                                </TooltipTrigger>
                                <ShadTooltipContent side="top" className="max-w-xs text-xs">
                                    <p>Tempo medio em dias que os negocios permanecem em cada etapa do funil. Etapas com tempo elevado podem indicar gargalos no processo</p>
                                </ShadTooltipContent>
                            </ShadTooltip>
                        </TooltipProvider>
                    </div>
                    <CardDescription>Tempo médio dos negócios em cada etapa (dias)</CardDescription>
                </div>
            </CardHeader>
            <CardContent>
                {chartData.length === 0 ? (
                    <EmptyContentGhost />
                ) : (
                    <ChartContainer className="w-full h-[350px]" config={chartConfig}>
                        <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 40, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" unit="d" />
                            <YAxis dataKey="nome" type="category" width={120} tick={{ fontSize: 12 }} />
                            <Tooltip formatter={(value) => `${value} dias`} />
                            <Bar dataKey="avgDias" fill="#f59e0b" barSize={20} radius={[0, 4, 4, 0]}>
                                <LabelList dataKey="avgDias" position="right" fontSize={12} formatter={(v) => `${v}d`} />
                            </Bar>
                        </BarChart>
                    </ChartContainer>
                )}
            </CardContent>
        </Card>
    )
}
